/**
 * Represents the possible outcomes of a race-tolerant insert operation.
 */
export enum RaceTolerantInsertOutcome {
	/** Record was successfully inserted. */
	Inserted,

	/** Record was not inserted because it was already present. */
	AlreadyPresent
}